<!--
 * @Author: xuesong
 * @Date: 2021-04-25 11:20:59
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-30 16:19:55
 * @Description: 处方药品 extension -8
-->
<template>
  <div class="custom-8" :style="{backgroundColor: bgColor,color: color}">
    <div class="info-content">
      <div class="left">
        <div class="left-img">
          <img v-if="data.itemType.includes('药')" src="../../static/IM/eight-drug.png" alt="">
          <img v-else src="../../static/IM/eight-rehabilitation.png" alt="">          
        </div>
        <div class="left-content">
          <div class="title">{{data.itemType}}</div>
          <div class="descript">{{data.itemName}}</div>
        </div>        
      </div>      
      <div class="seytm_punch">
        <div class="yes-drug">
          <div><span class="drug-count">{{data.count}}</span>次</div>
          <div>总打卡</div>

        </div>
        <div class="no-drug">
          <div><span class="drug-count-red">{{data.finishCount}}</span>次</div>
          <div>未打卡</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    data:{
      type: Object,
      default: ()=>{}
    },
     bgColor:{
      type: String,
      default: '#F5F5F5'
    },
    color:{
      type: String,
      default: '#333'
    }
  }
}
</script>

<style scoped lang="less">
.custom-8{
// min-width: 300px;
max-width: 350px;
border-radius: 4px;
.info-content {
        padding:15px 20px;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left{
          display: flex;
          .left-img{
            margin-right: 15px;
            img{
              width: 60px;
              height: 60px;
            }
          }
          .left-content{
            display: flex;
            flex-direction: column;
            // align-items: center;
            justify-content: center;
            
            .title{
              font-size: 12px;
              font-weight: 600;
              color: #333
            }
            .descript{
              font-size: 11px;
              font-weight: 400;
              color: #666;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
             
              width: 150px;
              // 
              // #599CFF
            }

          }
        }
        .seytm_punch {
          display: flex;
          align-items: center;
          

          .yes-drug{
            display: flex;
            flex-direction: column;
            align-items: center;
            .drug-count{
              font-size: 18px;
              font-weight: 600;
              color: #599CFF
            }
            margin-right: 10px;
          }
          .no-drug{
            display: flex;
            flex-direction: column;
            align-items: center;
          .drug-count-red{
            font-size: 18px;
            font-weight: 600;
            color: #FB5555 ;
          }
          }

        }
      }
}
</style>